/* -- Message Types -- */

export const isBroadcastMessage = message => 'group' in message;

/* -- Host Context -- */

/* -- Embedded Context -- */